import Image from "@/components/AppImage";
import benefits_icon_1 from "/public/img/benefits-icon-1.png";
import benefits_icon_2 from "/public/img/benefits-icon-2.png";
import benefits_icon_3 from "/public/img/benefits-icon-3.png";
import benefits_icon_4 from "/public/img/benefits-icon-4.png";
import benefits_icon_5 from "/public/img/benefits-icon-5.png";
import benefits_icon_6 from "/public/img/benefits-icon-6.png";

const Benefits = () => {
  return (
    <section className="benefits-section">
      <div className="overlay pt-120 pb-120">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-lg-9">
              <div className="section-header text-center">
                <h2 className="title">What you unlock in insights</h2>
                <p>
                  Every payout and deposit feeds a live picture of your
                  business—so you can price smarter, chase fewer late invoices,
                  and plan taxes with confidence.
                </p>
              </div>
            </div>
          </div>
          <div className="top-wrapper">
            <div className="row wrapper">
              <div className="col-lg-4 col-md-6">
                <div className="single-item text-center">
                  <div className="icon">
                    <Image src={benefits_icon_1} alt="icon" />
                  </div>
                  <h6>Crypto transactions & VIP status</h6>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-item text-center">
                  <div className="icon">
                    <Image src={benefits_icon_2} alt="icon" />
                  </div>
                  <h6>Fee and FX transparency</h6>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-item text-center">
                  <div className="icon">
                    <Image src={benefits_icon_3} alt="icon" />
                  </div>
                  <h6>Cash-flow forecasts</h6>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-item text-center">
                  <div className="icon">
                    <Image src={benefits_icon_4} alt="icon" />
                  </div>
                  <h6>Multi-currency totals</h6>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-item text-center">
                  <div className="icon">
                    <Image src={benefits_icon_5} alt="icon" />
                  </div>
                  <h6>CSV &amp; accountant exports</h6>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-item text-center">
                  <div className="icon">
                    <Image src={benefits_icon_6} alt="icon" />
                  </div>
                  <h6>Custom alerts on income swings</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
